import { useEffect, useState } from 'react';
import { useContracts } from './useContracts';

const POLL_MS = 60000;

export const usePlanConfig = () => {
  const c = useContracts();
  const [data, setData] = useState({ loading: true, config: null, cutoff: null, ranks: [], error: null });

  useEffect(() => {
    let mounted = true;
    let timer;
    const load = async () => {
      try {
        const [config, cutoff, ranks] = await Promise.all([
          c.read.views.getPlanConfig(),
          c.read.views.getCutoffInfo(),
          c.read.views.getAllRanks(),
        ]);
        if (!mounted) return;
        setData({ loading: false, config, cutoff, ranks, error: null });
      } catch (e) {
        if (!mounted) return;
        setData((s) => ({ ...s, loading: false, error: e?.message || 'Config load failed' }));
      }
    };
    load();
    timer = setInterval(load, POLL_MS);
    return () => { mounted = false; clearInterval(timer); };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return data;
};
